import { NgModule } from '@angular/core';
import { MsContentComponent } from './ms-content.component';
import { SharedLibsModule } from 'app/shared/shared-libs.module';

@NgModule({
	declarations: [MsContentComponent],
	imports: [SharedLibsModule],
	exports: [MsContentComponent],
	providers: [],
})
export class MsContentModule {}
